export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: '极速秒播',
      desc: '智能CDN加速技术，全国300+节点覆盖，点击即播无需等待缓冲，告别加载焦虑。',
    },
    {
      icon: 'ri-4k-line',
      title: '超清画质',
      desc: '全站支持1080P至4K超清画质播放，自适应码率切换，流畅观影不卡顿。',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日同步更新',
      desc: '内容团队7x24小时运营，热播剧集与卫视、流媒体同步上线，追剧绝不落伍。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '免费无需注册',
      desc: '打开即看，无需付费或注册。坚持免费看全集理念，让每个人都享受高品质影视内容。',
    },
  ];

  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            平台优势
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">极速影视为你打造的四大核心观影体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="group p-6 bg-background-100 rounded-xl border border-background-200/50 cursor-pointer hover:border-accent-500/20 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-500/10 flex items-center justify-center mb-4 group-hover:bg-accent-500/20 transition-colors">
                <i className={`${f.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-100 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}